import showToast from '../../Components/Common/SweetAlert/ToastAlert'
import { updateInvitedTeamMember } from '../../redux/event/manageEvents/actions'
import { fetchTeamMemberEvent } from '../../redux/event/teamMemberEvents/action'
import { fetchGeolocation } from '../../redux/geoLocation/geoLocationSlice'
import { AppDispatch, useAppDispatch } from '../../redux/store'

interface UpdateEventPayload {
  teamMemberEmail: string
  teamMemberWorkdayId: string
  eventId: string | number
  status: string
}

const useUpdateTeamMemberEvent = () => {
  const dispatch: AppDispatch = useAppDispatch()

  const handleUpdateEvent = async (payload: UpdateEventPayload) => {
    try {
      const locationResult = await dispatch(fetchGeolocation())
      const address = locationResult.payload

      // Update the team member event with the fetched address
      await dispatch(updateInvitedTeamMember({ ...payload, address }))
      showToast('success', 'Registered successfully!')
    } catch (error) {
      showToast('error', 'Error registering for event!')
    } finally {
      await Promise.all([
        dispatch(
          fetchTeamMemberEvent({
            teamMemberWorkdayId: payload.teamMemberWorkdayId,
            teamMemberEmail: payload.teamMemberEmail,
          }),
        ),
      ])
    }
  }

  return {
    handleUpdateEvent,
  }
}

export default useUpdateTeamMemberEvent
